import { ShelfConfig } from '@amp/web-app-components/config/components/shelf';
import type {
    ArrowOffset,
    GridType,
    AspectRatioOverrideConfig,
} from '@amp/web-app-components/src/components/Shelf/types';

const defaultShelfConfig = ShelfConfig.get();
const { GRID_MAX_CONTENT, GRID_VALUES, GRID_ROW_GAP } = defaultShelfConfig;

ShelfConfig.set({
    ...defaultShelfConfig,
    GRID_MAX_CONTENT: {
        ...GRID_MAX_CONTENT,
        shelfListItem: GRID_MAX_CONTENT['2-2-3-4'],
        shelfListItemListScreen: GRID_MAX_CONTENT['2-2-3-4'],
    },
    GRID_VALUES: {
        ...GRID_VALUES,
        shelfListItem: GRID_VALUES['2-2-3-4'],
        shelfListItemListScreen: {
            xsmall: null,
            small: 1,
            medium: 2,
            large: 3,
            xlarge: 3,
        },
    },
    GRID_ROW_GAP: {
        ...GRID_ROW_GAP,
        shelfListItem: GRID_ROW_GAP.None,
        shelfListItemListScreen: GRID_ROW_GAP.None,
    },
});

interface ExtendedShelfConfig {
    gridType: GridType;
    arrowOffset?: ArrowOffset;
    aspectRatioOverride?: AspectRatioOverrideConfig;
    overrides?: any;
    gridRows?: number;
}

export const SHELF_ITEM_CONFIG_MAPPING: { [key: string]: ExtendedShelfConfig } =
    {
        flowcaseLockup: {
            gridType: 'A',
            arrowOffset: [{ direction: 'top', offset: 38 }],
        },
        squareLockup: {
            gridType: 'G',
            arrowOffset: [{ direction: 'bottom', offset: 25 }],
            overrides: {
                large: {
                    gridType: 'C',
                },
            },
        },
        brickLockup: {
            gridType: 'G',
            arrowOffset: [{ direction: 'bottom', offset: 32 }],
            overrides: {
                large: {
                    gridType: 'C',
                },
            },
        },
        shelfListItem: {
            gridType: 'shelfListItem',
            gridRows: 3,
        },
        shelfListItemListScreen: {
            gridType: 'shelfListItemListScreen',
            gridRows: 3,
        },
        ellipseLockup: {
            gridType: 'H',
            overrides: {
                large: {
                    gridType: 'C',
                },
            },
        },
        editorsChoiceLockup: {
            gridType: 'Single',
        },
    };

export function getShelfConfig(itemKind: string): ExtendedShelfConfig {
    const defaultConfig = ShelfConfig.get();
    const config = SHELF_ITEM_CONFIG_MAPPING[itemKind] || {
        gridType: '',
        ...defaultConfig,
    };
    return config;
}
